module.exports = __webpack_public_path__ + "img/sigin_get_3.0eb9b7d1.png";